 export default require('@sanity/client')({
  projectId: 'vdl3i2aa',
  dataset: 'production',
  token: '', // or leave blank to be anonymous user
  useCdn: false // `false` if you want to ensure fresh data,
})
